import React from "react";
import PropTypes from "prop-types";
import ViewContainer from "../shared/ViewContainer";
import Header from "../shared/Header";
import SanitizedText from "shared/components/SanitizedText";
import UserThumb from "shared/components/UserThumb";
import Str from "shared/components/Str";
import FadedScrollableText
	from "apps/messenger/components/Connections/shared/FadedScrollableText";

import "apps/messenger/components/Connections/Prematch/IntroConfirmation.scss";

function IntroConfirmation({ introSent, onClose, username, thumbs }) {
	return (
		<div
			className="prematch-intro-confirmation"
		>
			<ViewContainer onClose={onClose}>
				<div className="prematch-intro-confirmation-content">
					<div className="prematch-intro-confirmation-content-thumb">
						<UserThumb
							username={username}
							thumbs={thumbs}
							size="225x225"
							shape={UserThumb.displayTypes.Round}
						/>
					</div>
					<div className="prematch-intro-confirmation-content-body">
						<Header>
							<Str>You introduced yourself</Str>
						</Header>
						<div className="prematch-intro-confirmation-content-body-subtitle">
							<Str>You can keep talking if you match</Str>
						</div>
					</div>
					<div className="prematch-intro-confirmation-content-sent-intro">
						<FadedScrollableText>
							<div className="prematch-intro-confirmation-content-sent-intro-content">
								<div
									className="prematch-intro-confirmation-content-sent-intro-content-header"
								>
									<Str>You said</Str>
								</div>
								<SanitizedText
									className="prematch-intro-confirmation-content-sent-intro-content-body"
									text={introSent}
								/>
							</div>
						</FadedScrollableText>
					</div>
				</div>
			</ViewContainer>
		</div>
	);
}

IntroConfirmation.propTypes = {
	introSent: PropTypes.string.isRequired,
	onClose: PropTypes.func.isRequired,
	username: PropTypes.string.isRequired,
	thumbs: PropTypes.array.isRequired,
};

export default IntroConfirmation;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/Prematch/IntroConfirmation.jsx